import api from "../lib/api";
import {
  Complain,
  ComplainLog,
  UpdateComplainParam,
} from "../models/complain.model";
import { deleteConfirmDialog } from "./common.action";

export async function getComplainsByEventId(eventId: string) {
  return (
    await api<{ complains: Complain[] }>({
      url: `/complain/event/${eventId}`,
    })
  ).complains;
}

export async function updateComplain(param: UpdateComplainParam) {
  return (
    await api<{ complain: Complain }>({
      url: `/complain`,
      method: "PATCH",
      data: param,
    })
  ).complain;
}

export async function deleteComplain(param: Complain) {
  await deleteConfirmDialog(() =>
    api({
      url: `/complain`,
      method: "DELETE",
      data: {
        id: param.eventId,
        sk: param.submitId,
      },
    })
  );
}

export async function getComplainLogs(param: {
  eventId: string;
  submitId: string;
}) {
  return (
    await api<{ logs: ComplainLog[] }>({
      url: `/complain/logs`,
      method: "POST",
      data: {
        id: param.eventId,
        sk: param.submitId,
      },
    })
  ).logs;
}